import { Component, OnInit, Input, Output, EventEmitter, ViewChild, } from "@angular/core";
import { PadronAguaGeneralesService } from "../../servicios/padron-agua-generales.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { PadronAguaGenerales, PadronAguaGeneralesInput, CalculoCargosAguasInput, CatUsuarios, CatAguaZonas, CatTipoTomas_, CatTipoUsos, RegistroFiscalizacionesInput, AguaBloqueos, FHistoricoReconexion } from '../../entidades/entidades';
import { MenuItem, SelectItem } from 'primeng/api';
import { CalculoCargosAguasService } from '../../servicios/calculo-cargos-aguas.service';
import { isNumeric } from "jquery";
import { runInThisContext } from "vm";
import Utils from "app/shared/utilerias/utils";
import { RegistroBitacoraInput, FGeneraBloqueoMasivoInput } from '../../entidades/entidades'
import { RegistroBitacoraService } from '../../servicios/registro-bitacora.service';

//-----------------------Ejecucion Fiscal-------------------------
import { CatTipoDocumentos, GeneraFiscalizacionesInput, GeneraFiscalizaciones, DatosCartoweb, AuxJasper, ParametroJasper, CancelaFiscalizacionesInput, CancelaFiscalizaciones, AplicaFiscalizacionesInput, AplicaFiscalizaciones, CatColonias } from 'app/entidades/entidades';
import { CatTipoDocumentosService } from "../../servicios/cat-tipo-documentos.service";
import { CatUsuariosService } from '../../servicios/cat-usuarios.service';
import { GeneraFiscalizacionesService } from "../../servicios/genera-fiscalizaciones.service";
import { CancelaFiscalizacionesService } from "../../servicios/cancela-fiscalizaciones.service";
import { AplicaFiscalizacionesService } from "../../servicios/aplica-fiscalizaciones.service";
import { FGeneraBloqueoMasivoService } from "../../servicios/f-genera-bloqueo-masivo.service";
import { AuthenticationService } from "app/servicios";
import { CatColoniasService } from "../../servicios/cat-colonias.service"
import { CatAguaZonasService } from "../../servicios/cat-agua-zonas.service"
import { CatTipoTomas_Service } from "../../servicios/cat-tipo-tomas.service";
import { CatTipoUsosService } from "app/servicios/cat-tipo-usos.service";
import { AguaBloqueosService } from "app/servicios/agua-bloqueos.service";
//----------------------------------------------------------------
import { ConfirmationService, MessageService } from 'primeng/api';
import { FHistoricoReconexionService } from "app/servicios/f-historico-reconexion.service";

@Component({
    selector: "app-padron-agua-generales",
    templateUrl: "./padron-agua-generales.component.html",
    styleUrls: ["./padron-agua-generales.component.css"],

    styles: [`
        .loading-text {
            display: block;
            background-color: #f1f1f1;
            min-height: 100px;
            animation: pulse 1s infinite ease-in-out;
            text-indent: -99999px;
            overflow: hidden;
        }
        tr.row-selec{ 
            background-color: #007ad9 !important; 
            color: white !important; 
        } 
  `]
})

export class PadronAguaGeneralesComponent implements OnInit {
    //-----------------------Ejecucion Fiscal-------------------------
    public id$: number;
    public idAgua: number;
    public cuentaAgua: number;
    public idTipoDocumento: number;
    public selecteddoc2: any;
    public selectedtoma2: any;
    public selecteduso2: any;
    public selectedUs2: any;
    public idAguas: string;
    public registroBitacora = new RegistroBitacoraInput();
    public rutas:number;
    public cuentasAgua: string;
    public arregloIdsAgua: any[];
    public auxJasperRecepcion: any[];
    public aguaBloqueos: AguaBloqueos;
    displayDialog: boolean = false;
    displayHistorico: boolean = false;
    public flagCarga: boolean = false;
    userInput: any ;
    GeneeraInput:  FGeneraBloqueoMasivoInput = new FGeneraBloqueoMasivoInput;
    //-----------------//
    propietario: string = null;
    cuenta_desde: number = null;
    cuenta_hasta: number = null;
    ruta: any;
    idColonia: number = null;
    input_busquedaP: string;
    ult_anio_fact: number;
    ult_bim_fact: number;
    rango_monto_ini: number;
    rango_monto_fin: number;
    idTipoToma: number;
    idTipoUso: number;
    rango_vencimiento_ini: Date;
    rango_vencimiento_fin: Date;
    fecha_inicio_reconexion: Date;
    fecha_fin_reconexion:Date;
    vallecturas: boolean = false;
    periodosVencidos: number;
    estaSeleccionado: boolean = false;

    //-----------------//
    public usuario: any;
    message: string;
    errorMessage: any;
    padronAguaGenerale: PadronAguaGenerales = new PadronAguaGenerales();
    selecteddoc: CatTipoDocumentos;
    selectedtoma: CatTipoTomas_;
    selecteduso: CatTipoUsos;
    selectedUs: CatUsuarios;
    usuariosSelec: SelectItem[];
    catColonias: SelectItem[];
    catColonia: CatColonias;
    catAguaZonas: SelectItem[];
    catAguaZona: CatAguaZonas;
    @ViewChild(PadronAguaGeneralesComponent, { static: false }) childPadronAguaGenerales;
    catTipoDocumentos: CatTipoDocumentos[];
    catTipoDocumentosFrom: FormGroup;
    catTipoTomas: CatTipoTomas_[];
    catTipoUso: CatTipoUsos[];
    catUsuarios: CatUsuarios[];
    generaFiscalizaciones: GeneraFiscalizaciones;
    cancelaFiscalizaciones: CancelaFiscalizaciones;
    aplicaFiscalizaciones: AplicaFiscalizaciones;
    public calculoCargosAguasInput: CalculoCargosAguasInput;
    public auxJasper: AuxJasper;
    display: boolean = false;
    public id_cargo: number;
    public jasperRecepcion$ = new EventEmitter<AuxJasper>();

    idRow: number = -1;
    numsRows: any[] = [];

    showDialog() {

        this.display = true;
    }
    first = 0;
    @Input("generaFiscalizacionesInput") generaFiscalizacionesInput: GeneraFiscalizacionesInput;
    // @Input("registroFiscalizacionesInput") registroFiscalizacionesInput: RegistroFiscalizacionesInput;
    @Input("cancelaFiscalizacionesInput") cancelaFiscalizacionesInput: CancelaFiscalizacionesInput;
    @Input("aplicaFiscalizacionesInput") aplicaFiscalizacionesInput: AplicaFiscalizacionesInput;

    //----------------------------------------------------------------

    muestraMensaje = new MuestraMensaje();
    padronAguaGenerales: PadronAguaGenerales[];
    itemsMenu: MenuItem[];
    columnasTabla: any[];
    dialogVisible: boolean;
    text: string;
    exportColumns: any[];
    clonedPadronAguaGenerales: { [s: string]: PadronAguaGenerales } = {};
    buscando: boolean = false;
    fHistoricoReconexion: any;
    public PadronAguaGeneralesSeleccionados: PadronAguaGenerales[];
    public progressBar = false;
    columnasTablafHistoricoReconexion: any[];
    registroFiscalizacionesInput: RegistroFiscalizacionesInput;
    @Input("padronAguaGeneralesInput") padronAguaGeneralesInput: PadronAguaGeneralesInput;
    // @Output("padronAguaGeneralesOutput") padronAguaGeneralesOutput: EventEmitter<PadronAguaGenerales>;

    constructor(
        private formBuilder: FormBuilder,
        private padronAguaGeneralesService: PadronAguaGeneralesService,
        private catTipoDocumentosService: CatTipoDocumentosService,
        private generaFiscalizacionesService: GeneraFiscalizacionesService,
        private cancelaFiscalizacionesService: CancelaFiscalizacionesService,
        private aplicaFiscalizacionesService: AplicaFiscalizacionesService,
        private fGeneraBloqueoMasivoService: FGeneraBloqueoMasivoService,
        private authenticationService: AuthenticationService,
        private calculoCargosAguasService: CalculoCargosAguasService,
        private catUsuariosService: CatUsuariosService,
        private fHistoricoReconexionService: FHistoricoReconexionService,
        private registroBitacoraService: RegistroBitacoraService,
        private catColoniasService: CatColoniasService,
        private catAguaZonasService: CatAguaZonasService,
        private catTipoTomasService: CatTipoTomas_Service,
        private catTipoUsoService: CatTipoUsosService,
        private aguaBloqueosService: AguaBloqueosService,
        private confirmationService: ConfirmationService,
        muestraMensaje: MuestraMensaje) { }

    async ngOnInit() {
        this.columnasTablafHistoricoReconexion = [ 
            {field: "total", header: "Total",ordenar: true, styleHeader: "width: 150px;",},
            {field: "fechaPago", header: "Fecha Pago",ordenar: true, styleHeader: "width: 150px;",},
            {field: "serie", header: "Serie",ordenar: true, styleHeader: "width: 150px;",},
            {field: "folio", header: "Folio",ordenar: true, styleHeader: "width: 150px;",},
            {field: "cuentaAgua", header: "Cuenta Agua",ordenar: true, styleHeader: "width: 150px;",},
            {field: "derivada", header: "Derivada",ordenar: true, styleHeader: "width: 150px;",},
            {field: "estatus", header: "Estatus",ordenar: true, styleHeader: "width: 150px;",},
            {field: "uso", header: "Uso",ordenar: true, styleHeader: "width: 150px;",},
            {field: "usuarioEjecutor", header: "Usuario Ejecutor",ordenar: true, styleHeader: "width: 150px;",}, 
          ];
        

        this.getAllCatUsuarios();
        //////////////////////////Ejecucion Fiscal//////////////////////
        this.getAllCatTipoDucumentos();
        this.getAllCatTipoTomas();
        this.getAllTipoUso();
        this.getCatColonias();
        this.getCatAguaZonas();
        await this.authenticationService.getUserByToken();
        this.usuario = this.authenticationService.currentUserValue;
        /////////////////////////////////////////////////////////

        //  this.getAllPadronAguaGenerales(this.padronAguaGeneralesInput);

        await this.authenticationService.getUserByToken();
        this.usuario = this.authenticationService.currentUserValue;

        onchange;

        this.columnasTabla = [
            {
                field: "Checkbox",
                header: "",
                ordenar: false,
                styleHeader: "width: 30px;",
            },
            { field: "estatusFiscalizacion", header: "Estatus", ordenar: true, styleHeader: "width: 120px;", },
            { field: "cuentaAgua", header: "Contrato", ordenar: true, styleHeader: "width: 70px;", },
            { field: "derivada", header: "Derivada", ordenar: true, styleHeader: "width: 70px;", },
            { field: "nombreCompleto", header: "Nombre Completo", ordenar: true, styleHeader: "width: 200px;", },
            { field: "domicilio", header: "Domicilio", ordenar: true, styleHeader: "width: 300px;", },
            { field: "delegaciondescripcion", header: "Poblacion",ordenar: true, styleHeader: "width: 150px;",},
            { field: "colonia", header: "Colonia", ordenar: true, styleHeader: "width: 150px;", },
            { field: "calleprincipal", header: "Calle Principal",ordenar: true, styleHeader: "width: 150px;",},
            { field: "entrecalle1descripcion", header: "Entre Calle 1",ordenar: true, styleHeader: "width: 150px;",},
            { field: "entrecalle2descripcion", header: "Entre Calle 2",ordenar: true, styleHeader: "width: 150px;",},
            { field: "ruta", header: "Ruta", ordenar: true, styleHeader: "width: 60px;", },
            { field: "tipoServicio", header: "Tipo Servicio", ordenar: true, styleHeader: "width: 150px;", },
            { field: "tipoUso", header: "Tipo Uso", ordenar: true, styleHeader: "width: 125px;", },
            { field: "diametro", header: "Diámetro", ordenar: true, styleHeader: "width: 80px;", },
            { field: "fechaAlta", header: "Fecha Alta", ordenar: true, styleHeader: "width: 100px;", },
            { field: "numeroMedidor", header: "Número Medidor", ordenar: true, styleHeader: "width: 100px;", },
            { field: "tipoPeriodo", header: "Tipo Periodo", ordenar: true, styleHeader: "width: 100px;", },
            { field: "tipoBloqueo", header: "Tipo Bloqueo", ordenar: true, styleHeader: "width: 150px;", },
            { field: "tipoToma", header: "Tipo Toma", ordenar: true, styleHeader: "width: 100px;", },
            { field: "estatusCuenta", header: "Estatus Cuenta", ordenar: true, styleHeader: "width: 100px;", },
            { field: "tipoGrupoVulnerable", header: "Tipo Campaña", ordenar: true, styleHeader: "width: 150px;", },
            { field: "anioDesde", header: "Año Desde", ordenar: true, styleHeader: "width: 60px;", },
            { field: "anioHasta", header: "Año Hasta", ordenar: true, styleHeader: "width: 60px;", },
            { field: "periodoDesde", header: "Periodo Desde", ordenar: true, styleHeader: "width: 100px;", },
            { field: "periodoHasta", header: "Periodo Hasta", ordenar: true, styleHeader: "width: 100px;", },
            { field: "base", header: "Agua", ordenar: true, styleHeader: "width: 110px;", },
            { field: "drenaje", header: "Alcantarillado", ordenar: true, styleHeader: "width: 110px;", },
            { field: "manejo", header: "Saneamiento", ordenar: true, styleHeader: "width: 110px;", },
            { field: "infraestructura", header: "Infraestructura", ordenar: true, styleHeader: "width: 110px;", },
            { field: "actualizacion", header: "Actualización", ordenar: true, styleHeader: "width: 110px;", },
            { field: "recargos", header: "Recargos", ordenar: true, styleHeader: "width: 110px;", }, 
            { field: "otrosCargo", header: "Otros Cargos", ordenar: true, styleHeader: "width: 110px;", },
            { field: "convenio", header: "Convenio", ordenar: true, styleHeader: "width: 110px;", },
            { field: "ivaTotal", header: "Iva Total", ordenar: true, styleHeader: "width: 110px;", },
            { field: "importe", header: "Importe", ordenar: true, styleHeader: "width: 110px;", },
            // { field: "multasVigente", header: "Multas Vigente", ordenar: true, styleHeader: "width: 110px;", },
            // { field: "gastosVigente", header: "Gastos Vigente", ordenar: true, styleHeader: "width: 110px;", },
            { field: "descuento", header: "Descuento", ordenar: true, styleHeader: "width: 110px;", },
            { field: "redondeoRezago", header: "Redondeo Rezago", ordenar: true, styleHeader: "width: 110px;", },
            { field: "redondeo", header: "Redondeo", ordenar: true, styleHeader: "width: 110px;", },
            { field: "total", header: "Total", ordenar: true, styleHeader: "width: 110px;", },
            // { field: "calculoMulta", header: "Calculo Multa", ordenar: true, styleHeader: "width: 110px;", },
            { field: "calculoGastos", header: "Calculo Gastos", ordenar: true, styleHeader: "width: 110px;", },
            // { field: "totalMultasGastos", header: "Total Multas Gastos", ordenar: true, styleHeader: "width: 110px;", },
            // { field: "ultimoBimFactuarado", header: "Último Bim Facturado", ordenar: true, styleHeader: "width: 170px;", },
        ];
        this.exportColumns = this.columnasTabla.map(col => ({ title: col.header, dataKey: col.field }));
    }

    java(value) {
        var element = document.querySelectorAll('.ui-table-unfrozen-view')
        //ui-table-unfrozen-view is dynamically generated class for table body
        if (value == false) { //no data present
            element[0].classList.add('overFlowClass')
        } else {
            element[0].classList.remove('overFlowClass')
            //its necessary to remove class if data is there, otherwise two scrolls will appear
        }
    }

    // ===============================================================
    // ---------------------------------------------------------------
    //Buscar cuentas en Padron 
    async buscar() {

        if (this.progressBar) {
            return;
        }
        try {
            this.numsRows = [];
            //debugger;
            this.calculoCargosAguasInput = new CalculoCargosAguasInput();
            this.PadronAguaGeneralesSeleccionados = [];
            this.padronAguaGeneralesInput = new PadronAguaGeneralesInput();
            this.progressBar = true;

            // debugger;
            if (!this.ult_anio_fact &&
                !this.ruta &&
                !this.propietario &&
                !this.cuenta_desde &&
                !this.ult_bim_fact &&
                !this.rango_monto_ini &&
                !this.rango_monto_fin &&
                (this.idColonia == 0 || this.idColonia == null) &&
                (this.idTipoToma == 0 || this.idTipoToma == null) &&
                (this.idTipoUso == 0 || this.idTipoUso == null) &&
                !this.rango_vencimiento_ini &&
                !this.rango_vencimiento_fin &&
                !this.periodosVencidos&&
                !this.fecha_inicio_reconexion &&
                !this.fecha_fin_reconexion 
            ) {
                throw new Error("Debe capturar por lo menos un criterio de busqueda.");
            }

            this.padronAguaGeneralesInput.idAgua = null;
            this.padronAguaGeneralesInput.nombre = this.propietario;
            this.padronAguaGeneralesInput.ruta = this.ruta;
            this.padronAguaGeneralesInput.cuentaAguaDesde = this.cuenta_desde;
            this.padronAguaGeneralesInput.cuentaAguaHasta = this.cuenta_desde;
            this.padronAguaGeneralesInput.idColonia = this.idColonia;
            this.padronAguaGeneralesInput.ultAnioPag = this.ult_anio_fact;
            this.padronAguaGeneralesInput.ultPeriodoPag = this.ult_bim_fact;
            this.padronAguaGeneralesInput.rangoMontoIni = this.rango_monto_ini;
            this.padronAguaGeneralesInput.rangoMontoFin = this.rango_monto_fin;
            this.padronAguaGeneralesInput.idTipoToma = this.idTipoToma;
            this.padronAguaGeneralesInput.idTipoUso = this.idTipoUso;
            this.padronAguaGeneralesInput.fechaVencimientoIni = this.rango_vencimiento_ini;
            this.padronAguaGeneralesInput.fechaVencimientoFin = this.rango_vencimiento_fin;
            this.padronAguaGeneralesInput.periodosVencidos = this.periodosVencidos;
            this.padronAguaGeneralesInput.fechaInicioBloqueo = this.fecha_inicio_reconexion;
            this.padronAguaGeneralesInput.fechaFinBloqueo = this.fecha_fin_reconexion;

            //const datoRetorno = await this.calculoCargosAguasService.getBusquedas(this.calculoCargosAguasInput)

            if ((this.cuenta_hasta - this.cuenta_desde) > 500) {
                throw new Error("No puedes realizar una consulta mayor a 500 predios.")
            }
            else if ((this.ult_anio_fact && !this.ult_bim_fact) || (!this.ult_anio_fact && this.ult_bim_fact)) {
                throw new Error("Cuando la búsqueda es por el último periodo facturado, no puede ir vacío el campo del último año y periodo facturado.")
            }
            else if ((this.rango_monto_ini && !this.rango_monto_fin) || (!this.rango_monto_ini && this.rango_monto_fin)) {
                throw new Error("Cuando la búsqueda es por el filtro de montos, no puede ir vacío el campo de monto inicial y monto final.")
            }
            else if (this.periodosVencidos && (!this.ult_anio_fact || !this.ult_bim_fact)) {
                throw new Error("Cuando la búsqueda es por el filtro de periodo de adeudo, no puede ir vacío el campo del último año y periodo facturado.")
            }
            else {
                await this.getAllPadronAguaGenerales(this.padronAguaGeneralesInput);
            }

        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
            this.progressBar = false;
        } finally {
            console.log("Paso por getAllPadronAguaGenerales");
        }
    }


    //Metodos Exportar
    async getAllPadronAguaGenerales(PadronAguaGeneralesInput: PadronAguaGeneralesInput) {
        try {
            
            this.progressBar = true;
            this.padronAguaGenerale = null;
            const datoRetorno = await this.padronAguaGeneralesService

                .getBusquedas(PadronAguaGeneralesInput)
                .toPromise();
            //   debugger;

            this.padronAguaGenerales = datoRetorno;

            for (let i = 0; i < datoRetorno.length; i++) {
                
                {
                    if (datoRetorno[i].periodoDesde != null) {
                        let periodoDesde = datoRetorno[i].periodoDesde;
                        let periodoDesdeSeparado = periodoDesde.split("-");
                        let aux = "MEN-" + periodoDesdeSeparado[1] + "-" + periodoDesdeSeparado[0];
                        datoRetorno[i].periodoDesde = aux;
                    }
                    if (datoRetorno[i].periodoHasta != null) {
                        let periodoHasta = datoRetorno[i].periodoHasta;
                        let periodoHastaSeparado = periodoHasta.split("-");
                        let aux2 = "MEN-" + periodoHastaSeparado[1] + "-" + periodoHastaSeparado[0];
                        datoRetorno[i].periodoHasta = aux2;
                    }
                    if (datoRetorno[i].ultimoBimFactuarado != null) {
                        let ultimoBimFactuarado = datoRetorno[i].ultimoBimFactuarado;
                        let ultimoBimFactuaradoSeparado = ultimoBimFactuarado.split(".");
                        let aux3 = "MEN-" + ultimoBimFactuaradoSeparado[1] + "-" + ultimoBimFactuaradoSeparado[0];
                        datoRetorno[i].ultimoBimFactuarado = aux3;
                    }
                }
            }
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log("Paso por  getALLpadronAguaGenerales");
            this.progressBar = false;
        }
    }

    correccionBimestres(bimestreNumero: string) {
        switch (bimestreNumero) {
            case "1":
                return "1";
                break;
            case "2":
                return "1";
                break;
            case "3":
                return "2";
                break;
            case "4":
                return "2";
                break;
            case "5":
                return "3";
                break;
            case "6":
                return "3";
                break;
            case "7":
                return "4";
                break;
            case "8":
                return "4";
                break;
            case "9":
                return "5";
                break;
            case "10":
                return "5";
                break;
            case "11":
                return "6";
                break;
            case "12":
                return "6";
                break;
            default:
                break;
        }
    }

    showValLecturas(){
        this.vallecturas = true;
      }

    async getPadronAguaGenerales(id: number) {
        try {
            const datoRetorno = await this.padronAguaGeneralesService
                .getSingle(id)
                .toPromise();
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log("Paso por getPadronAguaGenerales");
        }
    }



    async limpiar() {

        this.selectedUs = new CatUsuarios;
        this.padronAguaGenerales = null;
        this.propietario = null;
        this.cuenta_desde = null;
        this.cuenta_hasta = null;
        this.ruta = null;
        this.input_busquedaP = null;
        this.selecteddoc = null;
        this.selectedtoma = null;
        this.selectedtoma2 = null;
        this.selecteduso = null;
        this.selecteduso2 = null;
        this.ult_anio_fact = null;
        this.ult_bim_fact = null;
        this.rango_monto_ini = null;
        this.rango_monto_fin = null;
        this.idColonia = null;
        this.idTipoToma = null;
        this.idTipoUso = null;
        this.rango_vencimiento_ini = null;
        this.rango_vencimiento_fin = null;
        this.periodosVencidos = null;
        this.fecha_inicio_reconexion = null;
        this.fecha_fin_reconexion = null;
        this.numsRows = [];
    }

    // ===============================================================
    // ----------------------------Ejecuion Fiscal-----------------------------------
    async getAllCatTipoDucumentos() {
        try {
            const datoRetorno = await this.catTipoDocumentosService.getByGrupo(2).toPromise();
            this.catTipoDocumentos = datoRetorno;

        } catch (e) {
            if (e.responde) throw { message: e.response.data }
            else throw e;
        } finally {
            console.log("Paso Por getAllCatTipoDucumentos", this.catTipoDocumentos)
        }

    }

    async getAllCatTipoTomas() {
        try {
            const datoRetorno = await this.catTipoTomasService.getAll().toPromise();
            this.catTipoTomas = datoRetorno;

        } catch (e) {
            if (e.responde) throw { message: e.response.data }
            else throw e;
        } finally {
            console.log("Paso Por getAllCatTipoTomas", this.catTipoTomas)
        }

    }

    async getAllTipoUso(){
        try {
            const datoRetorno = await this.catTipoUsoService.getAll().toPromise();
            this.catTipoUso = datoRetorno;

        } catch (e) {
            if (e.responde) throw { message: e.response.data }
            else throw e;
        } finally {
            console.log("Paso Por getAllTipoUso", this.catTipoUso)
        }

    }

    async getAllCatUsuarios() {
        try {
            this.id_cargo = 5;
            const datoRetorno = await this.catUsuariosService.getBusquedaEjecutor(this.id_cargo).toPromise();
            this.catUsuarios = datoRetorno;
            for (var i in this.catUsuarios) {
                this.catUsuarios[i].nombreUsuarioCompleto = this.catUsuarios[i].nombre + " " + this.catUsuarios[i].primerApellido + " " + this.catUsuarios[i].segundoApellido;
            }


        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log("Paso por getAllCatUsuarios");
        }
    }


    async generar(informacionGeneral: Object) {
        this.generaFiscalizacionesInput = new GeneraFiscalizacionesInput();
        //  debugger;
        if (this.buscando) {
            return;
        }
        try {
            this.buscando = true;

            for (var i in informacionGeneral) {

                if (informacionGeneral == null) {
                    throw new Error("Seleccionar una cuenta primero.");
                }
                else if (informacionGeneral[i].cuentaAgua == null) {
                    this.cuentaAgua = null;
                    this.cuentaAgua = informacionGeneral[i].cuentaAgua;
                    throw new Error("Seleccionar una cuenta de agua valida.");
                }
                else {

                    try {
                        //   debugger;
                        if (informacionGeneral[i].periodoDesde == informacionGeneral[i].periodoHasta) {
                            this.cuentaAgua = null;
                            this.cuentaAgua = informacionGeneral[i].cuentaAgua;
                            throw new Error("La cuenta: " + this.cuentaAgua + " no presenta adeudo mayor a 2 bimestres.");
                        }
                        if (informacionGeneral[i].total <= 0) {
                            this.cuentaAgua = null;
                            this.cuentaAgua = informacionGeneral[i].cuentaAgua;
                            throw new Error("La cuenta: " + this.cuentaAgua + " no tiene adeudo para notificarle.");
                        }
                        if (informacionGeneral[i].anomalia == true) {
                            this.cuentaAgua = null;
                            this.cuentaAgua = informacionGeneral[i].cuentaAgua;
                            throw new Error("La cuenta: " + this.cuentaAgua + " tiene Anomalias.");
                        }
                        if (informacionGeneral[i].acumulado == true) {
                            this.cuentaAgua = null;
                            this.cuentaAgua = informacionGeneral[i].cuentaAgua;
                            throw new Error("No se pude realizar un proceso fiscal porque la cuenta: " + this.cuentaAgua + " tiene Adeudo Acumulado.");
                        }
                        if (informacionGeneral[i].idEstatusCon == 1) {
                            this.cuentaAgua = null;
                            this.cuentaAgua = informacionGeneral[i].cuentaAgua;
                            throw new Error("No se pude realizar un proceso fiscal porque la cuenta: " + this.cuentaAgua + " tiene un Convenio vigente.");
                        }
                        if (informacionGeneral[i].idEstatusFis == 1) {
                            this.cuentaAgua = null;
                            this.cuentaAgua = informacionGeneral[i].cuentaAgua;
                            throw new Error("La cuenta: " + this.cuentaAgua + " tiene un proceso fiscal En Vigente.");
                        }
                        if (informacionGeneral[i].idEstatusFis == 3) {
                            this.cuentaAgua = null;
                            this.cuentaAgua = informacionGeneral[i].cuentaAgua;
                            throw new Error("La cuenta: " + this.cuentaAgua + " tiene un proceso fiscal En Proceso.");
                        }
                       
                        if (informacionGeneral[i].idEstatusFis == null) {
                            let aux = informacionGeneral[i].idAgua;

                            this.generaFiscalizacionesInput.idAgua.push(aux);
                            if (this.selecteddoc2) {
                                this.generaFiscalizacionesInput.idTipoDucumento = this.selecteddoc2.id;
                            }
                            if (this.selectedtoma2) {
                                this.generaFiscalizacionesInput.idTipoToma = this.selectedtoma2.id;
                            }
                            if (this.selecteduso2) {
                                this.generaFiscalizacionesInput.idTipoUso = this.selecteduso2.id;
                            }
                            if (this.selectedUs2) {
                                this.generaFiscalizacionesInput.idUsuario = this.selectedUs2.id;
                            }
                        }
                    } catch (e) {
                        this.muestraMensaje.error(e.message, "top", "center");
                    }
                }
            }
            if (this.generaFiscalizacionesInput.idAgua.length == 0) {
                throw new Error("Seleccionar una cuenta de agua valida.");
            } else if (!this.generaFiscalizacionesInput.idTipoDucumento) {
                throw new Error("Seleccionar el tipo de documento a Generar.");
            } else if (!this.generaFiscalizacionesInput.idUsuario) {
                throw new Error("Seleccionar un notificador.");
            } else {
                await this.getGeneraFiscalizaciones(this.generaFiscalizacionesInput);
                await this.registraBitacora('SE GENERO ');
                this.progressBar = false;
                informacionGeneral = [];
                this.buscar()

            }

        } catch (e) {
            this.buscando = false;
            informacionGeneral = [];
            this.muestraMensaje.error(e.message, "top", "center");
        } finally {
            this.buscando = false;
            console.log("Paso por Generar Fiscalizacion");
            informacionGeneral = [];
            //this.buscando =false;

        }


    }
    async registraBitacora(movimiento: any) {

        this.generaFiscalizacionesInput.idAgua.forEach(element => {

            this.registroBitacora.idAgua = element;
            this.registroBitacora.accion = movimiento + this.selecteddoc.descripcion.toUpperCase();
            const datoRetorno = this.registroBitacoraService.add(this.registroBitacora).toPromise();
        });


    }

    async getGeneraFiscalizaciones(generaFiscalizacionesInput: GeneraFiscalizacionesInput) {
        try {
            const datoRetorno = await this.generaFiscalizacionesService.getBusquedas(generaFiscalizacionesInput).toPromise();
            this.generaFiscalizaciones = datoRetorno;
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {

            this.muestraMensaje.notification("Proceso Concluido (Generar).", "top", "center");
            this.buscando = false;
            console.log("Paso por  getGeneraFiscalizaciones");
        }
    }

    async imprimir(informacionGeneral) {
        try {
            //debugger;
            this.progressBar = true;
            let _cuenta_agua = new ParametroJasper();
            let _fecha_ini = new ParametroJasper();
            let _fecha_fin = new ParametroJasper();
            let _ejecutor = new ParametroJasper();
            this.cuentasAgua = "";
            this.arregloIdsAgua = [];

            if (!informacionGeneral || informacionGeneral.length === 0) {
                if(this.selecteddoc2.descripcion !== 'Rep. Reconexiones'){
                throw new Error("Seleccionar una cuenta primero.");
                }
            }
            
            if (!this.selecteddoc2) {
                throw new Error("Debe seleccionar el tipo de documento deseado.");
            }

            if (this.selecteddoc2.descripcion == 'Rep. Reconexiones') {
                if(!this.fecha_inicio_reconexion && !this.fecha_fin_reconexion){
                    throw new Error("Debe Ingresar un rango de fechas.");
                }
                if (!this.selectedUs || !this.selectedUs.nombreUsuarioCompleto) {
                    throw new Error("Selecciona un usuario.");
                }
            }
            

            try {
                this.cuentaAgua = null;
                for (var i in informacionGeneral) {
                    this.cuentaAgua = informacionGeneral[i].cuentaAgua;
                    this.cuentasAgua +=  this.cuentaAgua + ",";
                    this.arregloIdsAgua.push(informacionGeneral[i].idAgua);
                }
                if (this.cuentasAgua.length > 0) {
                    this.cuentasAgua = this.cuentasAgua.substring(0, this.cuentasAgua.length - 1)
                }

                // ==================================================                
                // ==== Hace registro de la notificacino o corte ====
                // ==================================================
                this.registroFiscalizacionesInput = new RegistroFiscalizacionesInput();
                this.registroFiscalizacionesInput.idsAguas = this.arregloIdsAgua.join(",");
                this.registroFiscalizacionesInput.idUsuario = this.usuario.id;
                this.registroFiscalizacionesInput.idTipoDocumento = this.selecteddoc2?.id;
                this.registroFiscalizacionesInput.idUsuarioNotificador = this.selectedUs?.id;
                const datoRetornoF = await this.generaFiscalizacionesService.addFiscalizacion(this.registroFiscalizacionesInput).toPromise();

                // ==================================================
                // ==== Genera el PDF de notificacion o de corte ====
                // ==================================================                
                this.auxJasper = new AuxJasper();
                if (this.selecteddoc2.descripcion == 'Notificación') {                        
                    this.auxJasper.JasperReport.nombreReporte = "Notificacion_posible_corte";
                }
                if (this.selecteddoc2.descripcion == 'Corte') {
                    this.auxJasper.JasperReport.nombreReporte = "Notificacion_corte";
                }

                if (this.selecteddoc2.descripcion == 'Rep. Reconexiones') {
                    this.auxJasper.JasperReport.nombreReporte = "027_Reconexiones_Pasadas";
                    _fecha_ini.nombre = "_fecha_ini";
                    _fecha_ini.valor = this.fecha_inicio_reconexion + "";
                    this.auxJasper.ParametroJasper.push(_fecha_ini);

                    _fecha_fin.nombre = "_fecha_fin";
                    _fecha_fin.valor = this.fecha_fin_reconexion + "";
                    this.auxJasper.ParametroJasper.push(_fecha_fin);

                    _ejecutor.nombre = "_ejecutor";
                    _ejecutor.valor = this.selectedUs.nombreUsuarioCompleto + "";
                    this.auxJasper.ParametroJasper.push(_ejecutor);
                }


                this.auxJasper.JasperReport.tipo = "pdf";
                _cuenta_agua.nombre = '_id_agua';
                //_cuenta_agua.valor = this.cuentasAgua;
                _cuenta_agua.valor =this.arregloIdsAgua.join(",");
                await this.auxJasper.ParametroJasper.push(_cuenta_agua);
                this.showDialog();
                
                for (var i in informacionGeneral) {
                    informacionGeneral[i].estatusFiscalizacion = this.selecteddoc2.descripcion;
                }
                // Se comenta esta parte dado que se va a manejar directamente en la funcion de genera fiscalizacion o el boton de generar que esta en esa parte
                // El bloqueo y el cargo se generara, cuando ejecuten el boton "btn_aplicar"
                /*if (this.selecteddoc2.descripcion == 'Corte')
                {                        
                    this.aguaBloqueos = new AguaBloqueos();
                    for(var i in this.arregloIdsAgua)
                    {
                        this.aguaBloqueos.id = 0;
                        this.aguaBloqueos.idAgua = this.arregloIdsAgua[i];
                        this.aguaBloqueos.idUsuarioBloqueo = this.usuario.id;
                        this.aguaBloqueos.idEstatus = 1;
                        this.aguaBloqueos.idTipoBloqueo = 4;
                        this.aguaBloqueos.observaciones = 'Generado al imprimir el reporte de corte en el modulo de ejecución fiscal';

                        const datoRetorno = await this.addAguaBloqueos(this.aguaBloqueos);
                        this.aguaBloqueos.id = datoRetorno.id;
                    }
                }*/
                //this.buscar(); // Se quito la consulta, para que no demore cada vez que hagan esta accion.

            } catch (e) {
                informacionGeneral = [];
                this.muestraMensaje.error(e.message, "top", "center");
            }
            

        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
        } finally {
            console.log("Paso por imprimir");
            this.progressBar = false;
        }

    }
    

    async imprimirRecepcion() {
        try {
            debugger;
            this.auxJasper = new AuxJasper();
            this.auxJasper.JasperReport.nombreReporte = "Recepcion_ejecutores";
            this.auxJasper.JasperReport.tipo = "pdf";
        
            let _id_usuario = new ParametroJasper();
            _id_usuario.nombre = "_id_usuario";
            _id_usuario.valor = this.selectedUs2.id + "";
            this.auxJasper.ParametroJasper.push(_id_usuario);

            let _ruta = new ParametroJasper();
            _ruta.nombre = "_ruta";
            _ruta.valor = this.ruta + "";
            this.auxJasper.ParametroJasper.push(_ruta);
    
            // Encontrar la descripción por ID de ruta en catAguaZonas
            const descripcionRuta = this.catAguaZonas.find(zona => zona.value === this.ruta)?.label;
    
            let ruta_ = new ParametroJasper();
            ruta_.nombre = "ruta_";
            ruta_.valor = descripcionRuta ? descripcionRuta : 'SIN RUTA...';
            this.auxJasper.ParametroJasper.push(ruta_);
    
            let notificacion_limitacion = new ParametroJasper();
            notificacion_limitacion.nombre = "notificacion_limitacion";
            notificacion_limitacion.valor = this.estaSeleccionado.toString(); 
            this.auxJasper.ParametroJasper.push(notificacion_limitacion);
    
            this.display=true;
            this.showValLecturas();
        } catch (error) {
            console.error("Error al preparar el informe:", error);
            alert("No se pudo preparar el informe debido a un error.");
        } finally {
            console.log("Paso por imprimirRecepcion");
            this.progressBar = false;
        }
    }
    


        async imprimirReporteReconexion() {
            try {
                debugger;
                this.auxJasper = new AuxJasper();
                this.auxJasper.JasperReport.nombreReporte = "Bloqueo_reconexion";
                this.auxJasper.JasperReport.tipo = "pdf";
                
                let _ruta = new ParametroJasper();
                _ruta.nombre = "_ruta";
                _ruta.valor = this.ruta + "";
                this.auxJasper.ParametroJasper.push(_ruta);
            
                let _fecha_ini = new ParametroJasper();
                _fecha_ini.nombre = "_fecha_ini";
                _fecha_ini.valor = this.fecha_inicio_reconexion + "";
                this.auxJasper.ParametroJasper.push(_fecha_ini);

                let _fecha_fin = new ParametroJasper();
                _fecha_fin.nombre = "_fecha_fin";
                _fecha_fin.valor = this.fecha_fin_reconexion + "";
                this.auxJasper.ParametroJasper.push(_fecha_fin);
            
                this.display=true;
                this.showValLecturas();
              } catch (error) {
                console.error("Error al preparar el informe:", error);
                alert("No se pudo preparar el informe debido a un error.");
              } finally {
                console.log("Paso por Bloqueo reconexion");
                this.progressBar = false;
              }
            }
    
    
        async imprimirExcel(){
            try{
                
                if (!this.selecteddoc2) {
                    throw new Error("Debe seleccionar el tipo de documento (Rep. Reconexiones) para poder exportar a Excel.");
                }
                if (this.selecteddoc2.descripcion == 'Rep. Reconexiones') {
                    if(!this.fecha_inicio_reconexion && !this.fecha_fin_reconexion){
                        throw new Error("Debe Ingresar un rango de fechas.");
                    }
                    if (!this.selectedUs || !this.selectedUs.nombreUsuarioCompleto) {
                        throw new Error("Selecciona un usuario.");
                    }
                }

                this.progressBar = true;
                this.auxJasper = new AuxJasper();
                this.auxJasper.JasperReport.nombreReporte = "027_Reconexiones_Pasadas";
                this.auxJasper.JasperReport.tipo = "xlsx";

                let _fecha_ini = new ParametroJasper();
                _fecha_ini.nombre = "_fecha_ini";
                _fecha_ini.valor = this.fecha_inicio_reconexion + "";
                this.auxJasper.ParametroJasper.push(_fecha_ini);

                let _fecha_fin = new ParametroJasper();
                _fecha_fin.nombre = "_fecha_fin";
                _fecha_fin.valor = this.fecha_fin_reconexion + "";
                this.auxJasper.ParametroJasper.push(_fecha_fin);

                let _ejecutor = new ParametroJasper();
                _ejecutor.nombre = "_ejecutor";
                _ejecutor.valor = this.selectedUs.nombreUsuarioCompleto + "";
                this.auxJasper.ParametroJasper.push(_ejecutor);

                //parametro para filtrar campos en el reprote de tipo xlsx
                let _formato = new ParametroJasper();
                _formato.nombre = "_formato";
                _formato.valor = "xlsx";
                this.auxJasper.ParametroJasper.push(_formato);

            }catch(e){
                this.muestraMensaje.error(e.message, "top", "center");
            }finally{
                setTimeout(() => {
                    this.progressBar = false;
                  }, 3000);
            }
        }

    async addAguaBloqueos(aguaBloqueos) {
        try {
            const datoretorno = await this.aguaBloqueosService
                .add(aguaBloqueos)
                .toPromise();
            return datoretorno;
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log("Paso por addAguaBloqueos");
        }
      }

    

    onChange(event) {
        this.selecteddoc2 = null;
        this.selecteddoc2 = event.value;
    }
    onChangeR(event) {
        this.ruta = null;
        this.ruta = event.value;
    }
    onChangeTT(event) {
        this.selectedtoma2 = null;
        this.selectedtoma2 = event.value;
        this.idTipoToma = null;
        this.idTipoToma = event.value.id;
    }
    onChangeTU(event) {
        this.selecteduso2 = null;
        this.selecteduso2 = event.value;
        this.idTipoUso = null;
        this.idTipoUso = event.value.id;
    }
    onChangeUs(event) {
        this.selectedUs2 = null;
        this.selectedUs2 = event.value;
    }

    async cancelar(informacionGeneral: Object) {
        this.cancelaFiscalizacionesInput = new CancelaFiscalizacionesInput();
        if (this.buscando) {
            return;
        }
        try {
            this.buscando = true;
            for (var i in informacionGeneral) {
                if (informacionGeneral == null) {
                    throw new Error("Seleccionar una cuenta primero.");
                }
                else if (informacionGeneral[i].cuentaAgua == null) {
                    throw new Error("Seleccionar una cuenta de agua valida.");
                }
                else {
                    try {
                        if (informacionGeneral[i].idEstatusFis == null) {
                            this.cuentaAgua = null;
                            this.cuentaAgua = informacionGeneral[i].cuentaAgua;
                            throw new Error("La cuenta: " + this.cuentaAgua + " no tiene un proceso fiscal vigente.");
                        }
                        if (informacionGeneral[i].idEstatusFis == 1 || informacionGeneral[i].idEstatusFis == 3) {
                            this.cancelaFiscalizacionesInput.idAgua.push(informacionGeneral[i].idAgua);
                            if (this.selecteddoc2) {
                                if (informacionGeneral[i].idTipoDocumento == this.selecteddoc2.id) {
                                    this.cancelaFiscalizacionesInput.idTipoDucumento = this.selecteddoc2.id;
                                } else {
                                    throw new Error("Esta seleccionando un documento diferente al del proceso actual.");
                                }
                            }
                            this.cancelaFiscalizacionesInput.idUsuario = this.usuario.id;
                        }
                    } catch (e) {
                        this.muestraMensaje.error(e.message, "top", "center");
                    }
                }
            }
            if (this.cancelaFiscalizacionesInput.idAgua.length == 0) {
                throw new Error("Seleccionar una cuenta de agua valida.");
            } else if (!this.cancelaFiscalizacionesInput.idTipoDucumento) {
                throw new Error("Seleccionar el tipo de documento a Cancelar.");
            } else {
                informacionGeneral = null;
                await this.getCancelaFiscalizaciones(this.cancelaFiscalizacionesInput);
                await this.registraBitacora('SE CANCELA ');
                this.progressBar = false;
                this.buscar();
            }
        } catch (e) {
            this.progressBar = false;
            this.muestraMensaje.error(e.message, "top", "center");
        } finally {
            this.progressBar = false;
            informacionGeneral = null;
            console.log("Paso por cancelar Fiscalizacion");
        }
    }

    async getCancelaFiscalizaciones(cancelaFiscalizacionesInput: CancelaFiscalizacionesInput) {
        try {
            const datoRetorno = await this.cancelaFiscalizacionesService
                .getBusquedas(cancelaFiscalizacionesInput)
                .toPromise();
            this.cancelaFiscalizaciones = datoRetorno;
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            this.buscando = false;
            this.muestraMensaje.notification("Proceso Concluido (Cancelar).", "top", "center");
            console.log("Paso por  getCancelaFiscalizaciones");
        }
    }

    async aplicar(informacionGeneral, estatus) {
        this.aplicaFiscalizacionesInput = new AplicaFiscalizacionesInput();
        try {
            if (this.buscando) {
                return;
            }
            this.buscando = true;

            if (!informacionGeneral || informacionGeneral.length === 0) {
                throw new Error("Seleccionar una cuenta primero.");
            }

            for (var i in informacionGeneral) {
                if (informacionGeneral[i].noNotificacion) {throw new Error("Esta cuenta tiene un bloqueo.");}
                
                if (informacionGeneral[i].cuentaAgua == null) {throw new Error("Seleccionar una cuenta de agua valida.");}
                
                    try {
                        /*if (informacionGeneral[i].idEstatusFis == null) {
                            this.cuentaAgua = null;
                            this.cuentaAgua = informacionGeneral[i].cuentaAgua;
                            throw new Error("La cuenta: " + this.cuentaAgua + " no tiene un proceso fiscal.");
                        }
                        if (informacionGeneral[i].idEstatusFis == 1) {
                            this.cuentaAgua = null;
                            this.cuentaAgua = informacionGeneral[i].cuentaAgua;
                            throw new Error("La cuenta: " + this.cuentaAgua + " no tiene un proceso fiscal.");
                        }*/
                        //if (informacionGeneral[i].idEstatusFis == 3) {
                            let aux = informacionGeneral[i].idAgua;
                            this.aplicaFiscalizacionesInput.idAgua.push(aux);
                            // if (this.selecteddoc2) {
                            //     if (informacionGeneral[i].idTipoDocumento == this.selecteddoc2.id) {
                            //         this.aplicaFiscalizacionesInput.idTipoDucumento = this.selecteddoc2.id;
                            //     } else {
                            //         this.buscando = false;
                            //         throw new Error("Esta seleccionando un documento diferente al del proceso actual.");
                            //     }
                            // }
                        //}
                    } catch (e) {
                        this.buscando = false;
                        this.muestraMensaje.error(e.message, "top", "center");
                    }
            }
            //  debugger;
            if (this.selectedUs2) this.aplicaFiscalizacionesInput.idUsuario = this.selectedUs2.id;
            if (this.aplicaFiscalizacionesInput.idAgua.length == 0) {
                throw new Error("Seleccionar una cuenta de agua valida.");
            } 
            //else if(!this.aplicaFiscalizacionesInput.idTipoDucumento) {throw new Error("Seleccionar el tipo de documento a Aplicar.");} 
            /*else if (!this.aplicaFiscalizacionesInput.idUsuario) {
                throw new Error("Seleccionar un notificador.");
            } */else {
                //await this.getAplicaFiscalizaciones(this.aplicaFiscalizacionesInput);
                //await this.registraBitacora('SE APLICO ');
                await this.aplicaBloqueo(this.aplicaFiscalizacionesInput, estatus );

                //this.buscar()
            }
        } catch (e) {
            this.buscando = false;
            this.muestraMensaje.error(e.message, "top", "center");
        } finally {
            this.buscando = false;
            console.log("Paso por Aplicar Fiscalizacion");
        }
    }

    async generaCargos() {
        try{
            if (this.userInput.length > 0) 
            { 
                this.buscando = this.progressBar = true;
                this.GeneeraInput.observacion = this.userInput;
                await this.fGeneraBloqueoMasivoService.getBusquedas(this.GeneeraInput).toPromise();
                await this.buscar();
                this.userInput = '';
            }
            else 
                throw new Error("Agregue una observacion para continuar.");

                
            this.muestraMensaje.notification("Proceso Concluido (Aplicar).", "top", "center");
        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
        } finally {
            this.displayDialog = false;
            this.buscando = this.progressBar = false;
            console.log("Paso por Aplicar Fiscalizacion");
        }
    }
 

    async aplicaBloqueo(aplicaFiscalizacionesInput: AplicaFiscalizacionesInput, estatus: number = 5) {
        try {
            this.GeneeraInput.jsonAgua = aplicaFiscalizacionesInput.idAgua.toString();
            this.GeneeraInput.tipoBloqueo = "reconexion";
            this.GeneeraInput.idEstatus = estatus;
            /*await this.fGeneraBloqueoMasivoService.getBusquedas(this.GeneeraInput).toPromise();
            await this.buscar();*/
            this.displayDialog = true;

        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            this.buscando = false;
            console.log("Paso por  getAplicaFiscalizaciones");
        }
    }

    async getAplicaFiscalizaciones(aplicaFiscalizacionesInput: AplicaFiscalizacionesInput) {
        try {
            const datoRetorno = await this.aplicaFiscalizacionesService.getBusquedas(aplicaFiscalizacionesInput).toPromise();
            this.aplicaFiscalizaciones = datoRetorno;
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            this.buscando = false;
            this.muestraMensaje.notification("Proceso Concluido (Aplicar).", "top", "center");
            console.log("Paso por  getAplicaFiscalizaciones");
        }
    }

    async getCatColonias() {
        try {
            let datoRetorno = await this.catColoniasService.getAll().toPromise();

            //==========================================================================
            this.catColonias = datoRetorno.map((datos) => {
                return { label: datos.descripcion, value: datos.id };
            });
            this.catColonias.unshift({ label: 'SIN COLONIA...', value: null });
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log('Paso por getCatColonias')
        }
    }

    async getCatAguaZonas() {
        try {
            // let datoRetorno = await this.catAguaZonasService.getAgrupado().toPromise();
            let datoRetorno = await this.catAguaZonasService.getAll().toPromise();
            //==========================================================================
            this.catAguaZonas = datoRetorno.map((datos) => {
                // return { label: datos.descripcion, value: parseInt(datos.descripcion) };
                return { label: datos.descripcion, value: datos.id };
            });
            this.catAguaZonas.unshift({ label: 'SIN RUTA...', value: null });
        } catch (e) {
            if (e.response) throw { message: e.response.data };
            else throw e;
        } finally {
            console.log('Paso por getCatAguaZonas')
        }
    }

    onKeydown(event) {
        if (event.key === "Enter") {
            this.buscar();
        }
    }

    onRowSelect(event)
    {
        this.idRow = event.data.idAgua;
        this.numsRows.push(this.idRow);
    }
    
    onRowUnselect(event)
    {
        this.idRow = event.data.idAgua;
        var index = this.numsRows.indexOf(this.idRow);
        if (index !== -1) {
            this.numsRows.splice(index, 1);
        }
    }

    onSelectAll(informacionGeneral: Object) {
        try {
            this.numsRows = [];
            if (informacionGeneral == null) {
                throw new Error("Seleccionar una cuenta primero.");
            } else {
                for (var i in informacionGeneral) {
                    // Comprobar si el tipo de bloqueo es PRORROGA o ACLARACION
                    if (!informacionGeneral[i].noNotificacion) {
                        this.numsRows.push(informacionGeneral[i].idAgua);
                    }
                }
            }
        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
        } finally {
            console.log("Paso por seleccionar todo");
        }
    }

    async imprimirHistoricos()
    {
        try {
          if (this.progressBar) {
            return;
          }
            
          this.progressBar = true;
          let busqueda = new FHistoricoReconexion();
          const datoRetorno = await this.fHistoricoReconexionService.getBusquedas(busqueda).toPromise();
          this.fHistoricoReconexion = datoRetorno;
          this.displayHistorico = true;
 
        } catch (e) {
            this.muestraMensaje.error(e.message, "top", "center");
        } finally {
            console.log("Paso por imprimirHistoricos");
            this.progressBar = false;
        }
    }


}